import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _dec2, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, initialize, Field, FieldArray, change } from 'redux-form';
import { connect } from 'react-redux';
import { Spinner } from 'components';
import { addContract, setStep } from 'redux/modules/newContract';
import { LLTextField, LLDatePicker, LLDropDownList } from 'components/FormElements';

var styles = require('../NewContractForm/NewContractForm.scss');

var NewContractForm = (_dec = reduxForm({
  form: 'newContract',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false
}), _dec2 = connect(function (state) {
  return {
    newContract: state.form.newContract,
    contract: state.contract,
    active: state.form.newContract ? state.form.newContract.active : false,
    step: state.newContract.step,
    isLoadingFromSf: state.newContract.isLoadingFromSf
  };
}, {
  change: change,
  initialize: initialize,
  addContract: addContract,
  setStep: setStep
}), _dec(_class = _dec2(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(NewContractForm, _Component);

  var _super = _createSuper(NewContractForm);

  /* availableProducts = [
    {
      id: 2,
      title: 'expert',
      description: 'our expert plan',
      retailMonthlyPrice: 149,
      minimumMonthlyPrice: 49,
      retailSetupFee: 99,
      adsBudget: 25,
    },
    {
      id: 3,
      title: 'pro',
      description: 'our pro plan',
      retailMonthlyPrice: 149,
      minimumMonthlyPrice: 49,
      retailSetupFee: 99,
      adsBudget: 25,
    },
    {
      id: 4,
      title: 'concierge',
      description: 'our concierge plan',
      retailMonthlyPrice: 149,
      minimumMonthlyPrice: 49,
      retailSetupFee: 99,
      adsBudget: 25,
    },
  ];*/
  // JMW: Use only "Base License" for now (https://likeablelabs.atlassian.net/browse/LL-1106)
  function NewContractForm(props) {
    var _this;

    _classCallCheck(this, NewContractForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "availableProducts", [{
      id: 6,
      title: 'Base Plan',
      description: 'Grants access to Likeable Local’s dashboard and feature set, Facebook and X (Twitter) integration, and automatically posted content from Likeable Local’s Content Library.',
      retailMonthlyPrice: 149,
      minimumMonthlyPrice: 49,
      retailSetupFee: 99,
      monthlyCustomFee: 0,
      adsBudget: 25
    }, {
      id: 7,
      title: 'Custom Plan',
      description: 'Includes an initial Facebook Facelift, the creation of up to (4) custom, short-form Facebook posts per month, custom feature Facebook ads, and the opportunity to have a monthly custom strategy call with a dedicated Customer Service Representative.',
      retailMonthlyPrice: 149,
      minimumMonthlyPrice: 49,
      retailSetupFee: 49,
      monthlyCustomFee: 49,
      adsBudget: 50
    }]);

    _defineProperty(_assertThisInitialized(_this), "billingMethods", [{
      id: 6,
      title: 'Stripe Credit Card'
    }, {
      id: 7,
      title: 'Henry Schein'
    }, {
      id: 9,
      title: 'Manual'
    }]);

    _defineProperty(_assertThisInitialized(_this), "productChangeHandler", function (item) {
      if (item.id !== 7) {
        _this.props.change('monthlyCustomFee', 0);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderDropdownList", function (_ref) {
      var input = _ref.input,
          rest = _objectWithoutProperties(_ref, ["input"]);

      return /*#__PURE__*/React.createElement(LLDropDownList, _extends({
        items: rest.data
      }, input, rest));
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref2) {
      var input = _ref2.input,
          label = _ref2.label,
          type = _ref2.type,
          className = _ref2.className,
          inputStyles = _ref2.styles,
          style = _ref2.style,
          _ref2$meta = _ref2.meta,
          touched = _ref2$meta.touched,
          error = _ref2$meta.error;
      return /*#__PURE__*/React.createElement("div", {
        className: "form-group ".concat(error && touched ? 'has-error' : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-sm-12 ".concat(inputStyles.inputGroup)
      }, type === 'date' ? /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement(LLDatePicker, _extends({
        style: style
      }, input, {
        placeholder: label,
        id: input.name
      }))) : /*#__PURE__*/React.createElement(LLTextField, _extends({}, input, {
        placeholder: label,
        type: type,
        className: className,
        id: input.name,
        style: {
          width: '100%'
        }
      })), error && touched && /*#__PURE__*/React.createElement("div", {
        className: "text-danger"
      }, error)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderEditCustomerDetailsSection", function () {
      return /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-sm-6"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "firstName",
        type: "text",
        component: _this.renderInput,
        label: "First Name",
        className: "form-control",
        styles: styles
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-sm-6"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "lastName",
        type: "text",
        component: _this.renderInput,
        label: "Last Name",
        className: "form-control",
        styles: styles
      }))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-sm-12"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "email",
        type: "email",
        component: _this.renderInput,
        label: "Email",
        className: "form-control",
        styles: styles
      }))), /*#__PURE__*/React.createElement(Field, {
        name: "businessName",
        type: "text",
        component: _this.renderInput,
        label: "Business Name",
        className: "form-control",
        styles: styles
      }), /*#__PURE__*/React.createElement(Field, {
        name: "address1",
        type: "text",
        component: _this.renderInput,
        label: "Address Line 1",
        className: "form-control",
        styles: styles
      }), /*#__PURE__*/React.createElement(Field, {
        name: "address2",
        type: "text",
        component: _this.renderInput,
        label: "Address Line 2",
        className: "form-control",
        styles: styles
      }), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-sm-5"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "locality",
        type: "text",
        component: _this.renderInput,
        label: "City",
        className: "form-control",
        styles: styles
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-sm-4"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "region",
        type: "text",
        component: _this.renderInput,
        label: "State/Province",
        className: "form-control",
        styles: styles
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-sm-3"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "postcode",
        type: "text",
        component: _this.renderInput,
        label: "Zip Code",
        className: "form-control",
        styles: styles
      }))), /*#__PURE__*/React.createElement(Field, {
        name: "phone",
        type: "text",
        component: _this.renderInput,
        label: "Phone Number",
        className: "form-control",
        styles: styles
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderPaymentSection", function () {
      return /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12",
        style: {
          marginBottom: 20,
          marginTop: 50
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "paymentMethod",
        className: "col-sm-2"
      }, "Billing Method"), /*#__PURE__*/React.createElement(Field, {
        name: "paymentMethod",
        component: _this.renderDropdownList,
        data: _this.billingMethods,
        valueField: "id",
        textField: "title"
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "renderSelectProductsSection", function () {
      return /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row",
        style: {
          marginTop: 50
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-2"
      }, "Contract Start Date"), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-10"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "contractStartsAt",
        type: "date",
        component: _this.renderInput,
        className: "form-control",
        styles: styles
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "Product",
        className: "col-sm-2"
      }, "Product"), /*#__PURE__*/React.createElement(Field, {
        name: "Product",
        onChange: _this.productChangeHandler,
        component: _this.renderDropdownList,
        data: _this.availableProducts,
        valueField: "id",
        textField: "title"
      })), /*#__PURE__*/React.createElement(Field, {
        name: "quantity",
        type: "number",
        component: 'input',
        value: 1,
        label: "Quantity",
        className: "form-control",
        styles: styles,
        hidden: true
      }), /*#__PURE__*/React.createElement(Field, {
        name: "contractMonths",
        type: "number",
        component: _this.renderInput,
        label: "Contract Months",
        className: "form-control",
        styles: styles
      }), /*#__PURE__*/React.createElement(Field, {
        name: "setupFee",
        type: "number",
        component: _this.renderInput,
        label: "One Time Setup Fee",
        className: "form-control",
        styles: styles
      }), /*#__PURE__*/React.createElement(Field, {
        name: "monthlyFee",
        type: "number",
        component: _this.renderInput,
        label: "Recurring Monthly Fee",
        className: "form-control",
        styles: styles
      }), _this.props.newContract.values && _this.props.newContract.values.Product.id === 7 && /*#__PURE__*/React.createElement(Field, {
        name: "monthlyCustomFee",
        type: "number",
        component: _this.renderInput,
        label: "Custom Monthly Fee",
        className: "form-control",
        styles: styles
      }), /*#__PURE__*/React.createElement(Field, {
        name: "monthlyAdsBudget",
        type: "number",
        component: _this.renderInput,
        label: "Recurring Monthly Ads Budget",
        className: "form-control",
        styles: styles
      }));
    });

    _this.state = {
      selectedProductIndex: 0
    };
    return _this;
  }

  _createClass(NewContractForm, [{
    key: "render",
    value: function render() {
      var section = null;

      if (this.props.step === 1) {
        section = this.renderEditCustomerDetailsSection();
      } else if (this.props.step === 2) {
        section = this.renderSelectProductsSection();
      } else if (this.props.step === 3) {
        section = this.renderPaymentSection();
      }

      if (this.props.isLoadingFromSf) {
        section = /*#__PURE__*/React.createElement("div", {
          style: {
            minHeight: 100,
            position: 'relative'
          }
        }, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "form-horizontal"
      }, section);
    }
  }]);

  return NewContractForm;
}(Component), _defineProperty(_class2, "propTypes", {
  totalSteps: PropTypes.number,
  // eslint-disable-line react/no-unused-prop-types
  onSubmit: PropTypes.func.isRequired,
  // eslint-disable-line react/no-unused-prop-types
  step: PropTypes.number.isRequired,
  isLoadingFromSf: PropTypes.bool
}), _defineProperty(_class2, "defaultProps", {
  step: 1
}), _temp)) || _class) || _class);
export { NewContractForm as default };